import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Hand off static HTML fallbacks before React 19 takes ownership of the head.
document.querySelectorAll('[data-og-static-seo]').forEach(node => node.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
